import { useQuery } from "react-query";
import { getPendingReconciliationInvoices } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

export const useGetPendingReconciliationInvoices = () => {
  return useQuery(
    "GetPendingReconciliationInvoices",
    getPendingReconciliationInvoices,
    {
      refetchOnWindowFocus: false,
    }
  );
};
